<div
    *ngIf="zoomedImage"
    class="image-zoom-modal"
    tabindex="0"
    (click)="close.emit()"
    (keydown.escape)="close.emit()"
>
    <div
        class="image-zoom-modal__content"
        tabindex="0"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
    >
        <button
            type="button"
            class="image-zoom-modal__close"
            (click)="close.emit()"
            aria-label="Close modal"
        >
            <img
                src="assets/icons/close-icon.svg"
                alt=""
                class="w-8 h-8 opacity-80 hover:opacity-100"
            />
        </button>
        <img
            [src]="zoomedImage"
            class="max-w-full max-h-full object-contain"
            alt="Enlarged product image"
        />
    </div>
</div>
